import React from 'react';
import PropTypes from 'prop-types';
import { DeliveryRefinements } from '../FulfillmentFilters/DeliveryRefinements';

const { bool, func } = PropTypes;

const DeliveryRefinement = ({
  onDimensionChange,
  onRefinementChange,
  deselect
}) => {
  return (
    <DeliveryRefinements
      onDimensionChange={onDimensionChange}
      onRefinementChange={onRefinementChange}
      className="sui-pt-1"
      skipDeliveryAutoSelect
      deselect={deselect}
      addMarkupForSeo
    />
  );
};

DeliveryRefinement.propTypes = {
  onDimensionChange: func.isRequired,
  onRefinementChange: func.isRequired,
  deselect: bool
};

DeliveryRefinement.defaultProps = {
  deselect: false
};

export { DeliveryRefinement };